import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {getFriendMessages, setArrivalMessage} from "../../Redux/actions/messageAction";
import styled from "styled-components";
import {RiCheckFill, RiCheckDoubleFill} from "react-icons/ri";
import PuffLoader from "react-spinners/PuffLoader";

const ChatRoom = ({selectedContact, messages, getFriendMessages, setArrivalMessage, socket}) => {
    const [arrivalMessageState, setArrivalMessageState] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const scrollToBottom = (smooth) => {
        setTimeout(()=> {
            const section = document.querySelector('#messagesEnd');
            section.scrollIntoView({behavior: `${smooth ? 'smooth' : 'auto'}`, block: 'end'});
            }
            ,0);
    }

    useEffect(() => {
        async function fetchData() {
            if (selectedContact) {
                setIsLoading(true)
                await getFriendMessages(selectedContact.id);
                setIsLoading(false)
                scrollToBottom(false);
            }
        }

        fetchData();
    }, [selectedContact, getFriendMessages]);

    useEffect(() => {
        if (socket.current) {
            socket.current.on("msg-receive", (data) => {
                if (!!data)
                    setArrivalMessageState(data)
            });
        }
    });

    useEffect(() => {
        if (arrivalMessageState && arrivalMessageState.from === selectedContact.id) {
            setArrivalMessage({
                fromSelf: false,
                message: arrivalMessageState.message,
                date: arrivalMessageState.date,
                time: arrivalMessageState.time
            });
        }
    }, [arrivalMessageState, setArrivalMessage, selectedContact.id]);

    useEffect(() => {
        scrollToBottom(true);
    }, [messages]);

    return (
        <Container>
            <div className="chat-messages" id='messagesEnd'>
                {isLoading ?
                    <div className='spinner-container' ><PuffLoader color="#7269EF"/></div>
                    :
                    messages.map((message, index, array) => {
                        return (
                            <div key={index}>
                                {
                                    index === 0 || array[index - 1].date !== message.date
                                        ?
                                        <div className='date-container'>
                                            {
                                                message.date === new Date().getFullYear() + '-'
                                                + (new Date().getMonth().toString().length === 1 ? ('0' + (new Date().getMonth()+1)) : (new Date().getMonth()+1)) + '-'
                                                + (new Date().getDate().toString().length === 1 ? ('0' + new Date().getDate()) : new Date().getDate())
                                                    ? <p>Today</p>
                                                    : <p>{message.date}</p>
                                            }
                                        </div>
                                        : null}
                                <div
                                    className={`message ${
                                        message.fromSelf ? "sent" : "received"
                                    }`}
                                >
                                    <div className="content ">
                                        <span style={{whiteSpace: "pre-wrap"}}>{message.message}</span>
                                        <div className="msg-time">
                                            {message.is_read ? <RiCheckDoubleFill/> : <RiCheckFill/>}
                                            <p>{message.time}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </Container>
    );
}

ChatRoom.propTypes = {
    selectedContact: PropTypes.object,
    messages: PropTypes.array,
    getFriendMessages: PropTypes.func.isRequired,
    setArrivalMessage: PropTypes.func.isRequired,
    socket: PropTypes.object,
};

const mapStateToProps = (state) => ({
    selectedContact: state.contact.selectedContact,
    messages: state.message.messages,
    socket: state.auth.socket,
});

export default connect(mapStateToProps, {getFriendMessages, setArrivalMessage})(ChatRoom);

const Container = styled.div`
  overflow-y: auto;
  z-index: 1;
  background: white;
  
  &::-webkit-scrollbar {
    width: 0.5rem;

    &-thumb {
      background-color: #D1D6DB;
      width: 0.1rem;
      border-radius: 1rem;
    }
  }

  .spinner-container{
    display: flex;
    justify-content: center;
    padding-top: 50px;
  }
  
  .chat-messages {
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .message {
      display: flex;
      align-items: center;

      .content {
        max-width: 40%;
        overflow-wrap: break-word;
        padding: 1rem;
        font-size: 1.1rem;
        border-radius: 0.5rem;
        @media screen and (min-width: 720px) and (max-width: 1080px) {
          max-width: 70%;
        }
      }
    }

    .sent {
      justify-content: flex-end;

      .content {
        background-color: #F5F7FB;
      }
    }

    .received {
      justify-content: flex-start;

      .content {
        background-color: #7269EF;
        color: white;
      }
    }

    .msg-time {
      display: flex;
      gap: 3px;
      color: #B2B4F6;
      font-size: 12px;
      font-weight: 500;
      margin-top: 5px;
    }

    .date-container {
      position: relative;
      height: 1px;
      background-color: #F0EFF5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      margin-bottom: 15px;

      p {
        background-color: #F0EFF5;
        border-radius: 0.25rem;
        padding: 5px 10px;
        font-size: 0.80rem;
      }
    }
  }
`;